import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useShipmentModel } from "../shipmentModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { useShipmentDetailModel } from "./details/shipmentDetailModel";

export const DataBox = () => {
    const { selectedRowKeys, exportShipment, downloadTpl, loadData } = useShipmentModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const { updateFormVal } = useShipmentDetailModel(() => []);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let shipmentEditKey = "5-2";
        let isFindNav = findNav(shipmentEditKey);
        if (!isFindNav) {
            addNav(shipmentEditKey, { id: selectedRowKeys[0], mode: "edit" });
            updateFormVal(null);
        } else {
            globalPrompt("modal", {
                title: "出运跳转详情",
                type: "warning",
                text: "您还有出运详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(shipmentEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateFormVal(null);
                }
            })
        }
    }


    const action = <>

        <YhAuth resCode={ResourceAuthEnum.SH_ED_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => onEdit()}
            >编辑</Button>
        </YhAuth>

        {/* <YhAuth resCode={ResourceAuthEnum.DATA_S_EX}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => exportShipment()}
        >导出</Button>
        {/* </YhAuth> */}

    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}